'use strict';

angular.module('youth').controller('HomeCtrl', ['$cookies', 'domainSvc', 'overlaySvc', 'session', '$log', 'NotifyingSvc', function ($cookies, domainSvc, overlaySvc, session, $log, NotifyingSvc) {
  var vm = this,
      cookie = $cookies.get('thrive_seen');
  vm.session = session;

  NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.GET_AGREEMENTS, true);

  function showOverlay() {
    return !cookie && session.assessmentScores && !isNaN(findScore(session.assessmentScores));
  }

  function setSeenCookie() {
    var date = new Date();
    // use the constructor to create by milliseconds
    var tomorrow = new Date(date.getTime() + 24 * 60 * 60 * 1000);
    $cookies.put('thrive_seen', true, {
      domain: domainSvc.getRootDomain(),
      path: '/',
      expiration: tomorrow
    });
    // make sure we can retrieve the token
    return $cookies.get('thrive_seen') === true;
  }

  function findScore(assessmentScores) {
    for (var a in assessmentScores) {
      if (assessmentScores[a].hasOwnProperty('wellbeing')) {
        return Math.abs(parseInt(assessmentScores[a]['wellbeing']));
      } else if (assessmentScores[a].hasOwnProperty('WELLBEING')) {
        return Math.abs(parseInt(assessmentScores[a]['WELLBEING']));
      }
    }
  }

  function overlayAcknowledged() {
    $log.debug('user has seen thrive overlay');
    // set a cookie so we don't see this again today or until logout
    setSeenCookie();
  }

  if (showOverlay()) {
    overlaySvc.overlay({
      // this is a bit of a HACK - we look for the
      // any assessment with a wellbeing category
      // and show absolute value
      thrive: findScore(session.assessmentScores)
    }, {
      template: 'thrive'
    }, overlayAcknowledged);
  }
}]);